import React, { useState, useEffect } from "react";
import { plansEnvConfig } from "../../../common/envConfig";
import { toast } from "react-toastify";
import { FREE_TRIAL_PROMO_CODES } from "../constants/freeTrialPromocodes";
import { TextField } from "@material-ui/core";
import { applyDiscount } from "../utils/plans";

export const CouponInput = ({
  init,
  coupon,
  setCoupon,
  setShowFreeTrialMessage,
  discount,
  discountType,
  productId,
  subscriptionAmount,
  couponSuccess,
}) => {
  const handleCoupon = (e) => {
    setCoupon(e.target.value.toUpperCase());
    localStorage.setItem("promoCode", e.target.value.toUpperCase());
  };

  const handleApply = () => {
    const trimmed = coupon.trim().toUpperCase();
    if (!trimmed) {
      toast.error("Please enter a coupon code");
      return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const refRock = urlParams.get("REFERRALCODE");
    if (FREE_TRIAL_PROMO_CODES.includes(coupon) || refRock) {
      setShowFreeTrialMessage(true);
    } else {
      setShowFreeTrialMessage(false);
    }
    localStorage.setItem("promoCode", coupon);
    init();

    setCoupon(trimmed);
    toast.success("Coupon applied");
  };

  return (
    <>
      <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
        <div className="text-black font-bold text-sm text-nowrap">
          Coupon <span className="text-gray600 font-medium">(Optional)</span>
        </div>
        <div className="flex items-center gap-2 w-full max-w-[620px]">
          <TextField
            label="Coupon"
            margin="dense"
            onChange={handleCoupon}
            value={coupon.toUpperCase()}
            variant="outlined"
          />

          <button
            type="button"
            onClick={handleApply}
            className="w-fit min-h-9 h-9 rounded-full font-semibold text-sm btnPrimary500"
          >
            Apply
          </button>
        </div>
      </div>

      {discount > 0 &&
        subscriptionAmount > -1 &&
        subscriptionAmount <=
          applyDiscount({
            discount: discount,
            price: Number(plansEnvConfig[productId]) || 0,
            type: discountType,
          }) && (
          <div className="flex flex-col items-center justify-center gap-2">
            <p className="text-center">
              <span className="font-bold">Discount:</span> {discount}{" "}
              {discountType === "percent" ? "%" : "USD"}
            </p>

            {couponSuccess && (
              <p className="text-green600 text-center">Coupon Applied!</p>
            )}
          </div>
        )}
    </>
  );
};
